import { getState, patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { AuthResponse, LoginPayload } from '../models/auth';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

type User = {
  login: string,
  name: string
}

type CoreState = {
  user: User | null,
  authInfo: AuthResponse | null
};

const initialState: CoreState = {
  user: null,
  authInfo: null
};

export const AuthStore = signalStore(
  withState(initialState),
  withMethods((store, authService = inject(AuthService)) => {
    return ({
      login: rxMethod<LoginPayload>(
        pipe(
          switchMap((payload) => {
            return authService.login(payload).pipe(
              tapResponse({
              next: result => {
                patchState(store, { authInfo: result });
                window.location.reload(); // Refresh the browser
              },
              error: error => console.error(error)
              })
            );
            })
          )
          ),
          logout() {
          patchState(store, {
            authInfo: null
          });
          window.location.reload(); 
          },
          fetchCurrentUser: rxMethod<void>(
          pipe(
            switchMap(() => {
            return authService.getCurrentUser().pipe(
              tapResponse({
                next: result => patchState(store, {
                  user: {
                    name: result.TEXT,
                    login: result.LOGIN
                  }
                }),
                error: error => console.error(error)
              })
            );
          })
        )
      ),
      populateFromLocalStorage() {
        const fromLocalStorage = localStorage.getItem('AuthStore');
        if (fromLocalStorage) {
          const state = JSON.parse(fromLocalStorage);
          patchState(store, state);
        }
      }
    });
  }),
  withHooks({
    onInit(store) {
      store.populateFromLocalStorage();
      effect(() => {
        const state = getState(store);
        localStorage.setItem('AuthStore', JSON.stringify(state));
      });
    }
  })
);
